import { render, staticRenderFns } from "./OwalButton.vue?vue&type=template&id=0b62a714&scoped=true"
import script from "./OwalButton.vue?vue&type=script&lang=js"
export * from "./OwalButton.vue?vue&type=script&lang=js"
import style0 from "./OwalButton.vue?vue&type=style&index=0&id=0b62a714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b62a714",
  null
  
)

export default component.exports